import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOuti = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if (ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="UTI" />
                    <div style={{ textAlign: "left" }}>

                        <Input label="UTI" nome="tonomedautia" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="60vw" widthMobile="80vw" marginR="3vw" />
                        <Select label="Tipo" nome="toutiespecialista" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw"
                            array={["UTI ADULTO", "UTI NEONATAL", "UTI PEDIÁTRICA"]} />
                        <Select label="Tipo da Equipe" nome="toutitipoequipe" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Equipe Própria", "Híbrida", "Terceirizada"]} />
                        <Input label="Nº de Leitos" nome="toutialeitos" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes no Momento da Fiscalização" nome="toutiapacientesfiscalizacao" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes Assistidos" nome="toutiapacientesassistidos" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Select label="Está garantida a assistência da Terapia Ocupacional ao paciente(CONFORME RDC 07/2010 ANVISA)" nome="rdc0710" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="25vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Input label="Profissionais que assistem no setor" nome="toterapeutanosetoruti" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="30vw" widthMobile="80vw" marginR="3vw" />
                        <Select label="Há demanda desassistida?" nome="demandaDesassistida" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="25vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não", "Não se aplica"]} />
                        {RenderCondicional()}
                    </div>

                    <div style={{ textAlign: "left" }}>

                        <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n} nome="observacoes" />
                    </div>
                </Caixa >
            )

            function RenderCondicional() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["toutiespecialista"]
                if (array[modulo][n]["toutiespecialista"] === "UTI NEONATAL") {
                    campos.push(
                        <div>
                            <Select label="Aplica o Método Canguru" nome="canguru" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                                array={["Sim", "Não"]} />
                            <Select label="Conformidade com a Portaria 1683/2007 (Ministério Da Saúde)" nome="portaria1683" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                                array={["Sim", "Não"]} />
                        </div>
                    )
                }
                return campos
            }
        }
        return partes
    }
}
export default TOuti